import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const useRecaptcha = () => {
  const recaptchaRef = useRef(null);

  const RecaptchaComponent = <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} />;

  const executeRecaptcha = async () => {
    try {
      if (recaptchaRef.current?.executeAsync) {
        return await recaptchaRef.current?.executeAsync();
      }
      return null;
    } catch (error) {
      console.log("Error executing recaptcha", error);
      return null;
    }
  };

  const resetRecaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  return {
    RecaptchaComponent,
    executeRecaptcha,
    resetRecaptcha
  };
};

export default useRecaptcha;
